export default "/images/activity.png?719a958a9d5be6ead5ca4526adf5fc48";